import { markRaw } from 'vue';

export function markRawRecursive<T>(input: T): T {
  if (Array.isArray(input)) {
    for (const item of input) {
      markRawRecursive(item);
    }
    return input;
  }

  if (typeof input === 'object' && input !== null) {
    markRaw(input);
    return input;
  }

  return input;
}
